import { getImageURL } from '../api/axiosClient';

export const resolveMediaUrl = (path) => {
  if (!path) {
    return null;
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const sanitizedPath = path.replace(/^\/+/, '');
  // Route media through /api/uploads so it works when only /api is
  // forwarded to the Node backend by the hosting environment.
  return getImageURL(`/api/${sanitizedPath}`);
};
